import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useDebtReportCreate from "src/hooks/debt/useDebtReportCreate";
import useDebtReportProcess from "src/hooks/debt/useDebtReportProcess";
import useAuthGlobal from "src/context/useAuthGlobal";
import { COMMOM_STATUS } from "src/constant";
import appConfig from "src/config/env";
import CloseIcon from "@mui/icons-material/Close";
import { enqueueSnackbar } from "notistack";
import RangeCalendar from "src/components/shared/RangeCalendar";

const DebtReportConfirmPopup = ({ open, onClose, type }) => {
  const [date, setDate] = useState({ fromDate: null, toDate: null });
  const [isLoading, setIsLoading] = useState(false);
  const { trigger } = useDebtReportCreate();
  const [id, setId] = useState(null);
  const { mutate } = useDebtReportProcess(id);
  const { userMe } = useAuthGlobal();

  const handleClose = () => {
    onClose();
    setDate({ fromDate: null, toDate: null });
    setId(null);
    setIsLoading(false);
  };

  const handleSubmit = async (range) => {
    try {
      setIsLoading(true);
      const res = await trigger({
        body: {
          warehouse: userMe?.currentWarehouse?._id,
          type,
          input: {
            fromDate: range?.fromDate ?? undefined,
            toDate: range?.toDate ?? undefined,
          },
        },
      });
      if (res.success) {
        setId(res.data._id);
        handleClose();
        enqueueSnackbar("Xuất báo cáo thành công", { variant: "success" });
        return;
      }
      setIsLoading(false);
      enqueueSnackbar("Lỗi khi xuất báo cáo", { variant: "error" });
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Lỗi khi xuất báo cáo", { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleApply = (range) => {
    setDate(range);
    handleSubmit(range);
  };

  useEffect(() => {
    if (!id) return;
    const timer = setInterval(() => {
      mutate()
        .then((res) => {
          setIsLoading(false);
          if (res.success && res.data.status === COMMOM_STATUS.done) {
            window.open(`${appConfig.API_FILE}/${res.data.url}`, "_blank");
            clearInterval(timer);
            setId(null);
            handleClose();
            enqueueSnackbar("Xuất báo cáo thành công", { variant: "success" });
          }
        })
        .catch((err) => {
          setIsLoading(false);
          enqueueSnackbar("Lỗi khi xuất báo cáo", { variant: "error" });
        });
    }, 1000);
    return () => clearInterval(timer);
  }, [id]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xl"
    >
      <DialogTitle
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography
          variant="h6"
          fontWeight="bold"
        >
          Xuất báo cáo
        </Typography>
        <IconButton
          onClick={handleClose}
          size="small"
        >
          <CloseIcon color="black" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ width: "fit-content" }}>
        <RangeCalendar
          value={date}
          onApply={handleApply}
          onClose={handleClose}
          isLoading={isLoading}
          hideClearButton
        />
      </DialogContent>
    </Dialog>
  );
};

export default DebtReportConfirmPopup;
